import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useUIStore } from '../../store';
import { BookmarkProvider } from '../../hooks/useBookmarks';

/**
 * Main application shell layout.
 * Fixed left sidebar, top header bar, and scrollable content area.
 */
export const AppShell: React.FC = () => {
  const { isSidebarOpen, isSidebarCollapsed } = useUIStore();

  return (
    <BookmarkProvider>
    <div className="flex h-screen overflow-hidden bg-[#EDE6DE]">
      {/* Sidebar */}
      <Sidebar />

      {/* Mobile overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 z-20 bg-black/30 lg:hidden"
          onClick={() => useUIStore.getState().setSidebarOpen(false)}
        />
      )}

      {/* Main content area */}
      <div
        className={`flex flex-1 flex-col min-w-0 transition-all duration-300 ${
          isSidebarCollapsed ? 'lg:ml-20' : 'lg:ml-64'
        }`}
      >
        {/* Header */}
        <Header />

        {/* Page content */}
        <main className="flex-1 overflow-y-auto p-6">
          <div className="max-w-[1600px] mx-auto animate-fade-in">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
    </BookmarkProvider>
  );
};
